import { postRequest } from '@/core';
import { edi } from '@/requests';

export default async function(transmissionId) {
	let url = edi.resendOutboundTransmission(transmissionId);
	let result = await postRequest(url);
	return result;
}